function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ElSalvadorFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1324",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1324)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1324",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1324)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V9H24V3H0Z",
        fill: "#3D58DB"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#3D58DB"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.6941 11.8937C14.6941 13.4712 13.4152 14.75 11.8377 14.75C10.2602 14.75 8.98138 13.4712 8.98138 11.8937C8.98138 10.3162 10.2602 9.03732 11.8377 9.03732C13.4152 9.03732 14.6941 10.3162 14.6941 11.8937Z",
        stroke: "#E8AA00",
        strokeWidth: "0.5"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.358 10.2467C10.358 10.2467 9.64362 11.4225 9.64362 12.2296C9.64362 13.0368 10.4988 14.0513 11.8442 14.0513C13.1565 14.0513 14.0998 13.2674 14.1283 12.2296C14.1568 11.1918 13.4223 10.4531 13.4223 10.4531C13.4223 10.4531 13.838 11.9472 13.6302 12.5526C13.4223 13.158 12.7495 13.8905 11.8442 13.7973C10.9388 13.704 10.0796 12.5896 10.0796 12.2296C10.0796 11.8696 10.358 10.2467 10.358 10.2467Z",
        fill: "#1E601B"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.6204 12.2463H13.0259",
        stroke: "#188396",
        strokeWidth: "0.5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.8443 11.8545H12.914",
        stroke: "#E8AA00",
        strokeWidth: "0.5"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.0064 12.4334H10.7238L11.8755 10.5224L13.0064 12.4334Z",
        stroke: "#E8AA00",
        strokeWidth: "0.5"
      })]
    })]
  })]
}));
//# sourceMappingURL=ElSalvador.js.map